export default "__VITE_ASSET__D_2ghvQL__"